<app-lms-modal-frame [title]="'Add Area Details'" [pageHeadWidth]="300">
  <div modal-body class="container-fluid">
    <div class="row center-screen">
      <div class="container-sm center-container">

        <form [formGroup]="areaForm">
          <table class="table table-striped table-fixed table-sm mb-3" [style.width.px]="450">
            <tbody class="field-4column-label">
              <tr>
                <td>Region:</td>
                <td> {{selectedRegion.name}}
                </td>
              </tr>

              <tr>
                <td>Area name</td>
                <td>
                  <input formControlName="areaCtrl" lmsNoSpecials toUppercase type="text" required>
                  <div *ngIf="areaCtrl!.errors?.required && submitted" class="error-label">
                    Area is required
                  </div>
                  <div *ngIf="areaCtrl?.errors?.NoSpecials">
                    <small class="text-danger">
                      Special characters are not allowed.
                    </small>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </div>

  <div modal-actions class="flex-container">
    <button class="btn btn-primary btn-sm" mdbRipple type="button" (click)="close()">Close</button>
    <button class="btn btn-primary btn-sm" mdbRipple type="button" (click)="saveArea()">Save</button>
  </div>
</app-lms-modal-frame>
